import styled, { css } from "styled-components";
import { ITheme, Theme } from "../../shared/types";
import { IUploadStatus } from "./NewCompany";

export const Card = styled.div`
  -webkit-box-shadow: 5px 5px 15px -3px ${(p: ITheme) => p.theme.color[300]};
  box-shadow: 5px 5px 15px -3px ${(p: ITheme) => p.theme.color[300]};
  background-color: ${(p: ITheme) => p.theme.color.background};
  border-radius: 5px;
`;
export const DataGridWrapper = styled(Card)`
  margin-bottom: 24px;
  width: 100%;
`;
export const DataGridContainer = styled.div`
  height: calc(100vh - 210px);
  min-height: 320px;
`;
export const Status = styled.div<{ status: "pending" | "active" | "passive" }>`
  padding: 3px 5px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.status === "passive"
      ? "rgb(201, 75, 75, 0.5)"
      : props.status === "pending"
        ? "rgb(80, 235, 23, 0.2)"
        : "rgb(58, 143, 43, 0.2)"};
  color: ${(props) =>
    props.status === "passive"
      ? "rgb(173, 26, 26)"
      : props.status === "pending"
        ? "rgb(125, 168, 5)"
        : "rgb(29, 87, 19)"};
`;
export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  .btn {
    background-color: white;
    border: 1px solid gray;
    border-radius: 5px;
    padding: 3px 6px;
    cursor: pointer;
  }
  .viewBtn {
    color: #5949d1;
  }
  .deleteBtn {
    color: rgb(173, 26, 26);
  }
`;
export const AddCompany = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .title {
    text-align: center;
    font-size: 20px;
    padding: 12px;
    font-weight: 500;
    color: ${(props: ITheme) => props.theme.color[900]};
  }
  .add {
    font-size: 16px;
    padding: 5px 10px;
    border: 1px solid ${(props: ITheme) => props.theme.color[300]};
    border-radius: 3px;
    cursor: pointer;
    outline: none;
    background: ${(props: ITheme) => props.theme.color.background};
    color: ${(props: ITheme) => props.theme.color[900]};
  }
`;

export const Left = styled.div`
  flex: 1;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  .logo-frame {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #f8fafc;
  }
  .img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .logo-copy {
    display: flex;
    flex-direction: column;
    gap: 3px;
    text-align: center;
    color: #111827;
  }
  .logo-copy span {
    font-size: 12px;
    color: #6b7280;
  }
  .upload-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    color: #374151;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }
  .upload-button:hover {
    background: #f9fafb;
  }
  .upload-button .icon {
    font-size: 20px;
  }
  .file-input {
    display: none;
  }
`;
export const Right = styled.div`
  flex: 3;
  min-width: 0;
`;

export const InputForm = styled.form`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px 36px;
  .file {
    width: calc(50% - 18px);
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .upload-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    color: #374151;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
  .upload-button .icon {
    font-size: 20px;
  }
  .file-input {
    display: none;
  }
  .section-description {
    margin: 4px 0 0;
    font-size: 13px;
    color: #6b7280;
  }
  .input {
    width: calc(50% - 18px);
    min-width: 0;
  }
  .inputField {
    box-sizing: border-box;
    width: 100%;
    margin-top: 6px;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    color: #111827;
    font-size: 14px;
    outline: none;
  }
  .inputField:focus,
  .descriptionField:focus {
    border-color: #5949d1;
    box-shadow: 0 0 0 3px rgba(89, 73, 209, 0.12);
  }
  .inputTitle {
    display: block;
    padding: 0;
    color: #374151;
    font-size: 13px;
    font-weight: 600;
  }
  .full-width {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
  }
  .billing-address-group {
    margin-top: 4px;
    border-top: 1px solid #e5e7eb;
    padding-top: 24px;
  }
  .billing-address-title {
    margin: 0;
    font-size: 18px;
    font-weight: 650;
    color: #111827;
  }
  .billing-address-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 24px;
    margin-top: 18px;
  }
  .billing-address-grid .input {
    width: 100%;
  }
  @media (max-width: 700px) {
    .billing-address-grid {
      grid-template-columns: 1fr;
    }
  }
  .descriptionField {
    box-sizing: border-box;
    width: 100%;
    margin-top: 6px;
    padding: 10px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font: inherit;
    line-height: 1.5;
    resize: vertical;
    outline: none;
  }
`;

interface ISubmitButtonProps {
  theme: Theme;
  uploadStatus?: IUploadStatus;
}
export const SubmitButton = styled.button<ISubmitButtonProps>`
  width: 50%;
  padding: 11px 24px;
  border: none;
  border-radius: 8px;
  color: ${(p: ITheme) => p.theme.color.background};
  font-size: 14px;
  font-weight: 600;
  background-color: ${(p: ITheme) => p.theme.color[800]};
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    background-color: ${(p: ITheme) => p.theme.color[500]};
  }
  /* ${(props) => (props.uploadStatus === "UPLOADED" ? css`` : css``)} */
`;

export const Container = styled(Card)`
  display: flex;
  padding: 40px;
  margin-bottom: 24px;
  @media (max-width: 800px) {
    flex-direction: column;
    padding: 22px;
    ${Left} {
      width: 100%;
      flex-basis: auto;
      padding-bottom: 24px;
    }
    ${InputForm} .input,
    ${InputForm} .file {
      width: 100%;
    }
  }
`;
export const HeaderTitle = styled(Card)`
  text-align: center;
  font-size: 26px;
  padding: 12px;
  font-weight: 700;
  color: ${(props: ITheme) => props.theme.color[800]};
`;

export const EventSelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border: 1px solid ${(p: ITheme) => p.theme.color[300]};
  .inputTitle {
    padding: 5px;
  }
  .inputField {
    background-color: inherit;
    border: none;
    // border-bottom: 1px solid ${(p: ITheme) => p.theme.color[800]};
    padding: 5px 0px;
    font-size: 16px;
    outline: none;
  }
`;
